import discount from './discount.json';
import paymentIntegrations from './paymentIntegrations.json';
import settingsEmployees from './settingsEmployees.json';
import addressForm from './addressForm.json';
import discountPopup from './discountPopup.json';
import payment from './payment.json';
import advancedCustomerSearch from './advancedCustomerSearch.json';
import settings from './settings.json';
import alerts from './alerts.json';
import printCoupons from './printCoupons.json';
import settingsLanguage from './settingsLanguage.json';
import employee from './employee.json';
import productGroupEditTexts from './productGroupEditTexts.json';
import billTable from './billTable.json';
import employeeStats from './employeeStats.json';
import productGroup from './productGroup.json';
import settingsOnScreenKeyboard from './settingsOnScreenKeyboard.json';
import fiscalIntegration from './fiscalIntegration.json';
import product from './product.json';
import settingsPayment from './settingsPayment.json';
import campaigns from './campaigns.json';
import giftcard from './giftcard.json';
import productSearch from './productSearch.json';
import settingsPrinter from './settingsPrinter.json';
import cashInOut from './cashInOut.json';
import gridButtons from './gridButtons.json';
import changePassword from './changePassword.json';
import header from './header.json';
import returnTranslation from './return.json';
import installer from './installer.json';
import sale from './sale.json';
import settingsTaxRates from './settingsTaxRates.json';
import clockInOut from './clockInOut.json';
import layaway from './layaway.json';
import saleNotes from './saleNotes.json';
import settingsUserInterface from './settingsUserInterface.json';
import common from './common.json';
import shipping from './shipping.json';
import localDBs from './localDBs.json';
import shoppingCart from './shoppingCart.json';
import createCustomer from './createCustomer.json';
import login from './login.json';
import search from './search.json';
import shortcuts from './shortcuts.json';
import createNew from './createNew.json';
import customerButtons from './customerButtons.json';
import stockTransfer from './stockTransfer.json';
import settingsAgeVerification from './settingsAgeVerification.json';
import switchUser from './switchUser.json';
import customerInformation from './customerInformation.json';
import settingsAssociatePos from './settingsAssociatePos.json';
import taxExempt from './taxExempt.json';
import customer from './customer.json';
import offer from './offer.json';
import settingsCompany from './settingsCompany.json';
import unpaidInvoice from './unpaidInvoice.json';
import customerNotes from './customerNotes.json';
import settingsConfiguration from './settingsConfiguration.json';
import customerSearch from './customerSearch.json';
import openCloseDay from './openCloseDay.json';
import settingsCustomerDisplay from './settingsCustomerDisplay.json';
import validation from './validation.json';
import zReport from './zReport.json';
import order from './order.json';
import payCheckForm from './payCheckForm.json';
import settingsCustomPayment from './settingsCustomPayment.json';

export const es = {
  discount,
  paymentIntegrations,
  settingsEmployees,
  addressForm,
  discountPopup,
  payment,
  advancedCustomerSearch,
  settings,
  alerts,
  printCoupons,
  settingsLanguage,
  employee,
  productGroupEditTexts,
  billTable,
  employeeStats,
  productGroup,
  settingsOnScreenKeyboard,
  fiscalIntegration,
  product,
  settingsPayment,
  campaigns,
  giftcard,
  productSearch,
  settingsPrinter,
  cashInOut,
  gridButtons,
  changePassword,
  header,
  return: returnTranslation,
  installer,
  sale,
  settingsTaxRates,
  clockInOut,
  layaway,
  saleNotes,
  settingsUserInterface,
  common,
  shipping,
  localDBs,
  shoppingCart,
  createCustomer,
  login,
  search,
  shortcuts,
  createNew,
  customerButtons,
  stockTransfer,
  settingsAgeVerification,
  switchUser,
  customerInformation,
  settingsAssociatePos,
  taxExempt,
  customer,
  offer,
  settingsCompany,
  unpaidInvoice,
  customerNotes,
  settingsConfiguration,
  customerSearch,
  openCloseDay,
  settingsCustomerDisplay,
  validation,
  zReport,
  order,
  payCheckForm,
  settingsCustomPayment,
};
